import createReducer from "./createReducer";

export const DOWNLOAD_ACTIONS = {
	SET_DOWNLOAD_URL: "SET_DOWNLOAD_URL",
	CLEAR_URL: "CLEAR_URL",
};

export function downloadBlob(dispatch, resp, fileName){
	if(!resp.success || !resp?.payload?.data){ return resp; }

	let linkURL = generateBlobURL(resp.payload.data);
	if(linkURL){
		dispatch(downloadFile(linkURL, fileName));
	}

	return resp;
}

export function generateBlobURL(data){
	let linkURL = null;
	try {
		let blb = new Blob([data]);
		linkURL = window.URL.createObjectURL(blb);
	} catch(err){
		console.error("Unable to generate Blob");
		console.error(err);
	}

	return linkURL;
}

const CLEAR_TIMEOUT = 100;
export function downloadFile(url, name = null){
	return (dispatch) => {
		// HOPI-41 clear the URL before we set it this way if users click the same export multiple times, there's a change
		// Additionally, we have to add a short timeout so that React doesn't batch updates
		dispatch({ type:DOWNLOAD_ACTIONS.CLEAR_URL });

		setTimeout(() => {
			dispatch({
				type: DOWNLOAD_ACTIONS.SET_DOWNLOAD_URL,
				payload: { url, name },
			});
		}, CLEAR_TIMEOUT);
	};
}

const IT = {
	url: null,
	name: null,
};

const HANDLERS = {
	[DOWNLOAD_ACTIONS.SET_DOWNLOAD_URL]: setURL,
	[DOWNLOAD_ACTIONS.CLEAR_URL]: clearURL,
};

function setURL(state, action){
	return {
		url: action.payload.url,
		name: action.payload.name,
	};
}

function clearURL(){
	return { url: null, name: null };
}


export const REDUCERS = {
	setURL,
	clearURL,
};

let reducerConfig = {
	typeRoot: "DOWNLOAD",
	actionTypes: DOWNLOAD_ACTIONS,
	actionCreators: {
		downloadFile,
	},
	initialState: IT,
	HANDLERS,
};


export default createReducer(IT, HANDLERS);
export const Download = reducerConfig.actionCreators;
